/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/**
 * Return a certain parent
 * @param {String|Object} panelId - "listing", "view" or "nav"
 */
window.returnToParent = function returnToParent(panelId) {
  const panel = window.xGetElementById(panelId);

  const saving = window.saveOnChanges(panel).state() === 'pending';

  if (!panel) {
    if (saving) {
      return;
    }
    window.refreshPageToOriginal();
    return;
  }

  if (window.isWorking(panel)) {
    return;
  }

  if (!window.breadcrumbs || window.breadcrumbs.length <= 0) {
    if (saving) {
      return;
    }
    window.refreshPageToOriginal();
    return;
  }

  window.refreshContextRequests(panel.id, window.breadcrumbs.length);

  const parent_obj = window.breadcrumbs.pop();

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Breadcrumb | undefined' is not a... Remove this comment to see the full error message
  window.return_to_parent(panel, parent_obj);
};

/**
 * Return to a parent with a optional callback
 * instead of the window.return_to_parent calling OpenView or RefreshListing it can call your
 * custom call_back(panel,parent_type)
 * @param {String} panelId - "listing", "view" or "nav"
 * @param {Number} i - Crumb index
 * @param {Function} [call_back]
 */
window.returnToParentX = function returnToParentX(panelId, i, call_back) {
  const panel = window.xGetElementById(panelId);

  // return a promise from window.saveOnChanges so that the rest of the js isn't
  // executed until we've finished that business
  window.saveOnChanges(panel).done(() => {
    if (!window.merchantos.register.confirmForUnsavedCreditPayments()) {
      return;
    }

    if (!panel) {
      window.refreshPageToOriginal();
      return;
    }

    if (window.isWorking(panel)) {
      return;
    }

    if (!window.breadcrumbs || window.breadcrumbs.length <= 0) {
      if (!panel.parent_id) {
        window.refreshPageToOriginal();
      }

      return;
    }

    window.refreshContextRequests(panel.id, i);

    const go_back = i - window.breadcrumbs.length;

    while (window.breadcrumbs.length > i) {
      window.breadcrumbs.pop();
    }

    const parent_obj = window.breadcrumbs[window.breadcrumbs.length - 1];
    parent_obj.go_back = go_back;

    if (call_back) {
      window.return_to_parent(panel, parent_obj, call_back);
      return;
    }

    // Add a "dummy" parent that never really gets used so that popstate has a
    // parent to pop off.
    window.breadcrumbs.push(parent_obj);

    window.return_to_parent(panel, parent_obj);
  });
};

/**
 * Refresh the page to its original state
 */
window.refreshPageToOriginal = function refreshPageToOriginal() {
  const closing = window.closing;
  window.saveBeforeClose();
  window.closing = closing;

  if (window.merchantos.display.display_recorded) {
    window.merchantos.display.resetAll();
    window.merchantos.focus.restore();
    return;
  }

  const gpl = window.xGetElementById('gen_page_location');
  if (gpl) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'HTMLEleme... Remove this comment to see the full error message
    window.merchantos.utils.openUrl(gpl.value);
  }
};

/**
 * Return to a certain parent
 * instead of calling OpenView or RefreshListing it can call your
 * custom call_back(pannel,parent_type)
 * @param {String|Object} pannel - "listing", "view" or "nav"
 * @param {Object} parent_obj - Parent crumb object
 * @param {Function} [call_back]
 */
window.return_to_parent = function return_to_parent(pannel, parent_obj, call_back) {
  if (!parent_obj) {
    window.refreshPageToOriginal();
    return;
  }
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'PanelId'.
  const request = window.getContextRequest(pannel.id);
  if (parent_obj.type === 'listing') {
    try {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'PanelId... Remove this comment to see the full error message
      delete pannel.listing;
    } catch (e) {}

    // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | HTMLElement' is not assignable to ... Remove this comment to see the full error message
    pannel = window.getListingPannel(pannel);

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'PanelId... Remove this comment to see the full error message
    pannel.listing.name = parent_obj.name;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'PanelId... Remove this comment to see the full error message
    pannel.listing.title = parent_obj.title;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'PanelId... Remove this comment to see the full error message
    pannel.listing.count = parent_obj.count;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'PanelId... Remove this comment to see the full error message
    pannel.listing.page = parent_obj.page;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'PanelId... Remove this comment to see the full error message
    pannel.listing.saved_search = parent_obj.saved_listing_search;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'PanelId... Remove this comment to see the full error message
    pannel.listing.draw_all = true;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'PanelId... Remove this comment to see the full error message
    pannel.listing.request = request;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'PanelId... Remove this comment to see the full error message
    pannel.listing.go_back = parent_obj.go_back;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'stored_listing' does not exist on type '... Remove this comment to see the full error message
    pannel.stored_listing = parent_obj.stored_listing;

    if (call_back) {
      call_back(pannel, 'listing');
      return;
    }

    if (parent_obj.go_back) {
      window.history.go(parent_obj.go_back);
      return;
    }

    window.RefreshListing(pannel);
  } else if (parent_obj.type === 'view') {
    try {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'view' does not exist on type 'PanelId'.
      delete pannel.view;
    } catch (e) {}

    // @ts-expect-error ts-migrate(2322) FIXME: Type 'HTMLElement | undefined' is not assignable t... Remove this comment to see the full error message
    pannel = window.getViewPannel(pannel);

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'view' does not exist on type 'PanelId'.
    pannel.view.name = parent_obj.name;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'view' does not exist on type 'PanelId'.
    pannel.view.record_id = parent_obj.record_id;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'view' does not exist on type 'PanelId'.
    pannel.view.tab = parent_obj.tab;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'view' does not exist on type 'PanelId'.
    pannel.view.count = parent_obj.count;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'view' does not exist on type 'PanelId'.
    pannel.view.rec_num = parent_obj.rec_num;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'view' does not exist on type 'PanelId'.
    pannel.view.request = request;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'view' does not exist on type 'PanelId'.
    pannel.view.go_back = parent_obj.go_back;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'view' does not exist on type 'PanelId'.
    pannel.view.path = parent_obj.path;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'stored_listing' does not exist on type '... Remove this comment to see the full error message
    pannel.stored_listing = parent_obj.stored_listing;

    if (call_back) {
      call_back(pannel, 'view');
      return;
    }

    if (parent_obj.go_back) {
      window.history.go(parent_obj.go_back);
      return;
    }

    window.openView(pannel);
  } else if (parent_obj.type === 'ui_tab') {
    window.clearParents();
    window.window.merchantos.tabs.show(parent_obj.name);
  } else if (parent_obj.type === 'sale') {
    window.clearParents();
    window.merchantos.utils.openUrl('/register.php');
  }
};

/**
 * Create a Parent object
 * @param {String|Object} pannel_id - "linting", "view" or "nav"
 * @returns {Object}
 */
window.createParent = function createParent(pannel_id) {
  const pannel = window.xGetElementById(pannel_id);

  if (!pannel) return false;

  const parent_obj = {};

  if (pannel.current_type) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'type' does not exist on type '{}'.
    parent_obj.type = pannel.current_type;
  } else if (pannel.listing) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'type' does not exist on type '{}'.
    parent_obj.type = 'listing';
  } else if (pannel.view) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'type' does not exist on type '{}'.
    parent_obj.type = 'view';
  } else {
    return false;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'type' does not exist on type '{}'.
  if (parent_obj.type == 'listing') {
    if (!pannel.listing) return false;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'name' does not exist on type '{}'.
    parent_obj.name = pannel.listing.name;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type '{}'.
    parent_obj.title = pannel.listing.title;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'count' does not exist on type '{}'.
    parent_obj.count = pannel.listing.count;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'page' does not exist on type '{}'.
    parent_obj.page = pannel.listing.page;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'saved_listing_search' does not exist on ... Remove this comment to see the full error message
    parent_obj.saved_listing_search = window.cloneObject(pannel.listing.saved_search);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type '{}'.
    parent_obj.title = pannel.listing.title;
  } else {
    if (!pannel.view) return false;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'name' does not exist on type '{}'.
    parent_obj.name = pannel.view.name;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'record_id' does not exist on type '{}'.
    parent_obj.record_id = pannel.view.record_id;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type '{}'.
    parent_obj.title = pannel.view.title;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'tab' does not exist on type '{}'.
    parent_obj.tab = pannel.view.tab;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'count' does not exist on type '{}'.
    parent_obj.count = pannel.view.count;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'rec_num' does not exist on type '{}'.
    parent_obj.rec_num = pannel.view.rec_num;
  }
  if (pannel.stored_listing) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'stored_listing' does not exist on type '... Remove this comment to see the full error message
    parent_obj.stored_listing = {};
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'stored_listing' does not exist on type '... Remove this comment to see the full error message
    parent_obj.stored_listing.name = pannel.stored_listing.name;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'stored_listing' does not exist on type '... Remove this comment to see the full error message
    parent_obj.stored_listing.title = pannel.stored_listing.title;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'stored_listing' does not exist on type '... Remove this comment to see the full error message
    parent_obj.stored_listing.count = pannel.stored_listing.count;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'stored_listing' does not exist on type '... Remove this comment to see the full error message
    parent_obj.stored_listing.saved_search = pannel.stored_listing.saved_search;
  }
  return parent_obj;
};

/**
 * Push a view and breadcrums inside the history to help navigation
 * @param {String|Object} panelId - "listing", "view" or "nav" container
 * @param {Object} [parent_obj]
 */
window.pushParent = function pushParent(panelId, parent_obj) {
  const panel = window.xGetElementById(panelId);

  if (!panel) return;

  if (!parent_obj) {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | Partial<{ id: string; name: string... Remove this comment to see the full error message
    parent_obj = window.createParent(panel);
  }

  if (!parent_obj) return;

  if (!window.breadcrumbs) {
    window.breadcrumbs = [];
  }

  // If we're opening from a listing and have no previous parents that are
  // listings, assume the listing is the starting point
  if (panel.stored_listing && window.breadcrumbs.length <= 0) {
    // Also ensure the record type matches or we're looking at reports
    const objectRecordType = parent_obj.name.split('.')[0];
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'name' does not exist on type 'string'.
    if (panel.stored_listing.name.indexOf(objectRecordType) !== -1) {
      if (objectRecordType === 'admin') {
        // Many settings share the record type "admin"
        // We need to be more specific about the matching in this area
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'name' does not exist on type 'string'.
        const listingName = panel.stored_listing.name.split('.')[2];
        const viewName = parent_obj.name.split('.')[2];
        if (listingName.indexOf(viewName) !== -1) {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'type' does not exist on type 'string'.
          panel.stored_listing.type = 'listing';
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
          window.breadcrumbs.push(panel.stored_listing);
        }
      } else {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'type' does not exist on type 'string'.
        panel.stored_listing.type = 'listing';
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
        window.breadcrumbs.push(panel.stored_listing);
      }
    }
  }

  window.breadcrumbs.push(parent_obj);

  if (window.breadcrumbs.length > 30) {
    window.breadcrumbs.shift();
  }
};

/**
 * Remove/pop last breadcrumbs
 */
window.popParent = function popParent() {
  if (window.breadcrumbs && window.breadcrumbs.length >= 1) {
    window.breadcrumbs.pop();
  }
};

/**
 * Remove all breadcrumbs when navigating to different sections
 */
window.clearParents = function clearParents() {
  const panel = window.xGetElementById('view');
  if (panel) {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'string | un... Remove this comment to see the full error message
    panel.stored_listing = null;
  }

  window.breadcrumbs = [];
};

/**
 * Set a crumb url
 * @param {String} url - Url the crumb will lead to
 * @param {String} [title] - Crumb's title
 */
window.setLinkTo = function setLinkTo(url, title) {
  // compare parameters from current and new url. If they are the same then don't update history.
  const current_params = window.merchantos.utils.getQueryParams(window.location.search);
  const new_params = window.merchantos.utils.getQueryParams(url);

  let equal = true;

  $.each(current_params, param => {
    if (
      new_params[param] !== '' &&
      (!new_params[param] || new_params[param] !== current_params[param])
    ) {
      equal = false;
      return false;
    }
    return true;
  });

  $.each(new_params, param => {
    if (
      current_params[param] !== '' &&
      (!current_params[param] || current_params[param] !== new_params[param])
    ) {
      equal = false;
      return false;
    }
    return true;
  });

  // Params are the same, we don't want to do anything
  if (equal) {
    history.changeState();
    return;
  }

  let viewContext = {};

  if (new_params.form_name === 'view') {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'Partial<{ name: string; title: string; recor... Remove this comment to see the full error message
    viewContext = window.getViewPannel('view').view;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'stored_listing' does not exist on type '... Remove this comment to see the full error message
    viewContext.stored_listing = window.getViewPannel('view').stored_listing;
  }

  let replace_history = false;
  // If the view name hasn't changed, check breadcrumbs to see whether the
  // current view was added to the history or replaced
  if (
    current_params.name &&
    current_params.name === new_params.name &&
    window.breadcrumbs &&
    (window.breadcrumbs.length <= 2 ||
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'record_id' does not exist on type 'Bread... Remove this comment to see the full error message
      window.breadcrumbs[window.breadcrumbs.length - 2].record_id !== current_params.id)
  ) {
    replace_history = true;
  }

  if (title) {
    const index = title.indexOf(':');
    if (index !== -1) {
      title = `${title.substring(0, index + 1)}<var>${title.substring(
        index + 1,
        title.length
      )}</var>`;
    }
  }

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
  window.updateHistory(url, title, replace_history, viewContext);
  history.changeState();

  window.updateBodyAttributes();
};

/**
 * Set crumbs
 * @param {Array} crumbs - List of crumbs
 */
window.setCrumbs = function setCrumbs(crumbs) {
  const topBar = $('.js-topbar');
  if (!topBar[0]) {
    return;
  }

  let renamedCrumbs =
    Array.isArray(window.breadcrumbs) && window.breadcrumbs.length ? window.breadcrumbs : crumbs;

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (renamedCrumbs[0].title === 'Roll-Up Reports') {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    renamedCrumbs.unshift({ title: 'Reports', name: 'reports', type: 'ui_tab' });

    // @ts-expect-error ts-migrate(2322) FIXME: Type 'Breadcrumb[] | undefined' is not assignable ... Remove this comment to see the full error message
    window.breadcrumbs = renamedCrumbs;
  }

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  renamedCrumbs = renamedCrumbs.map(crumb => {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
    const formattedCrumb = window.renameCrumbTitle(crumb.title);
    return {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'text' does not exist on type 'string'.
      text: formattedCrumb.text,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'varText' does not exist on type 'string'... Remove this comment to see the full error message
      varText: crumb.varText || formattedCrumb.varText,
      name: crumb.name,
      type: crumb.type,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'path' does not exist on type 'Breadcrumb... Remove this comment to see the full error message
      path: crumb.path,
    };
  });

  window.merchantos.asyncSubscribe.notifySubscribers('react.mount.topbar', {
    props: {
      crumbs: renamedCrumbs,
    },
  });
  topBar.toggleClass(
    'notranslate',
    (renamedCrumbs[0].name && /^system\.?/.test(renamedCrumbs[0].name)) || false
  );
};

/**
 * Rename crumb title depending on the section
 * @param {String} title - Current section name
 * @returns {String} - Renamed crumb title
 */
// @ts-expect-error ts-migrate(2322) FIXME: Type '(title: string) => "" | { text: string; }' i... Remove this comment to see the full error message
window.renameCrumbTitle = function renameCrumbTitle(title) {
  if (!title) return '';

  const isNew = /:\s?New$/.test(title);
  let newTitle = {
    text: title,
  };

  if (/^.+?:.*/.test(title)) {
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    title.replace(/^(.+?:)\s*(.*)/i, (_match, text, varText) => {
      if (text === 'Transaction Details :') {
        text = 'Transaction';
      } else if (text === 'Item:') {
        text = '';
      } else if (text === 'Purchase:') {
        text = 'PO:';
      } else if (text === 'Shop:') {
        text = '';
      }

      if (isNew) {
        newTitle.text = `${text} ${varText}`;
      } else {
        newTitle.text = text;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'varText' does not exist on type '{ text:... Remove this comment to see the full error message
        newTitle.varText = varText;
      }
    });
  } else if (title === 'Lightspeed Retail') {
    if (window.location.pathname === '/register.php') {
      newTitle = {
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ icon: string; text: string; }' is not assi... Remove this comment to see the full error message
        icon: 'register',
        text: 'Sales',
      };
    }
  }

  return newTitle;
};

/**
 * Generate a crumb object
 * @param {String} title - Current section title
 * @returns {Object}
 */
window.crumbItem = function crumbItem(title, name) {
  return { title, name };
};

/**
 * Refresh page header
 * @param {String} panelId - "listing", "view" or "nav"
 */
window.refreshPageHeader = function refreshPageHeader(panelId) {
  const panel = window.getRealPannel(panelId);

  // see if there are no parents, if not then the title should just be
  // the title of this view/listing
  let title;
  let name;
  if (panel.current_type === 'view') {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    title = panel.view.title;
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    name = panel.view.name;
  } else if (panel.listing) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type 'Partial<{... Remove this comment to see the full error message
    title = panel.listing.title;
    name = panel.listing.name;
  } else if (panelId === 'register') {
    title = window.config.app_ui_name;
    name = 'register';
  }

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
  window.setCrumbs([window.crumbItem(title, name)]);
  const href = window.merchantos.utils.generatePageUrl(panel);
  window.setLinkTo(href, title);
};

/**
 * Write body attributes when the window.location changes
 * to allow filtering through mixpanel autotrack
 */
window.updateBodyAttributes = function updateBodyAttributes() {
  if (typeof mixpanel === 'undefined') return;

  const allowedAttrs = ['data-pathname', 'data-name', 'data-form_name', 'data-tab', 'data-view'];

  const queryString = window.location.search;

  let queryParams = [];

  const bodyAttrs = {};

  let oneQueryParam;

  $('body').removeAttr(allowedAttrs.join(' '));

  if (window.location.pathname.length > 1) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    bodyAttrs['data-pathname'] = window.location.pathname.substring(1).replace(/\..+$/, '');
  }

  if (queryString.length > 1) {
    queryParams = queryString.substring(1).split('&');

    // eslint-disable-next-line no-plusplus
    for (let i = 0, ii = queryParams.length; i < ii; ++i) {
      oneQueryParam = queryParams[i].split('=');
      oneQueryParam[0] = `data-${oneQueryParam[0]}`;

      if (~allowedAttrs.indexOf(oneQueryParam[0])) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        bodyAttrs[oneQueryParam[0]] = oneQueryParam[1];
      }
    }
  }

  if (Object.keys(bodyAttrs).length) {
    $('body').attr(bodyAttrs);
  }
};

$(() => window.updateBodyAttributes());
